// One 1-second clock for every timer on the page: a row that shows a running time subscribes; nothing else redraws
// with it. The interval runs only while someone listens.
import { useSyncExternalStore } from "react";

let now = Date.now();
let timer = 0;
const listeners = new Set<() => void>();

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  if (!timer) {
    now = Date.now();
    timer = window.setInterval(() => { now = Date.now(); for (const l of listeners) l(); }, 1000);
  }
  return () => {
    listeners.delete(fn);
    if (!listeners.size) { clearInterval(timer); timer = 0; }
  };
}

/** The time, updated once a second while the caller is mounted. */
export function useNow(): number {
  return useSyncExternalStore(subscribe, () => now, () => now);
}

export function secs(ms: number): string {
  const s = Math.max(0, ms) / 1000;
  return s < 10 ? `${s.toFixed(1)} s` : s < 60 ? `${Math.round(s)} s` : `${Math.floor(s / 60)} min ${Math.round(s % 60)} s`;
}
